import { baseModule } from '@/container-modules/base-module';
import { createModule } from '@/container-modules/create-module';
import { gridModule } from '@/container-modules/grid-module';
import { headerServiceModule } from '@/container-modules/header-service-module';
import { biTrackModule } from '@eureka/domains';
import { saveToProjectModule } from '@eureka/shared/save-to-project/services';
import { Container } from '@patsnap/tahiti-core/shared/inversify';
import { pageModule } from './container-modules/page-module';
import { trackModule } from './container-modules/track-module';

const container = new Container({
    defaultScope: 'Singleton',
    skipBaseClassChecks: true,
});

container.load(
    baseModule,
    headerServiceModule,
    createModule,
    gridModule,
    pageModule,
    trackModule,
    biTrackModule,
    saveToProjectModule
);

export {
    container,
};
